import { render, staticRenderFns } from "./curso-progreso.vue?vue&type=template&id=43b0217e&scoped=true&"
import script from "./curso-progreso.vue?vue&type=script&lang=ts&"
export * from "./curso-progreso.vue?vue&type=script&lang=ts&"
import style0 from "./curso-progreso.vue?vue&type=style&index=0&id=43b0217e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b0217e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressLinear,VRow})
